import { EncumbranceTypes } from './encumbranceOptions';

type EncumbranceCoOwnersConfig = {
  // eslint-disable-next-line
  [key in EncumbranceTypes]: {
    sectionTitle: string;
    hasMembersSelector: boolean;
    categoryId?: string;
  };
};

export const encumbranceCoOwnersConfig: EncumbranceCoOwnersConfig = {
  [EncumbranceTypes.CO_OWNERSHIP]: {
    sectionTitle: 'Co-owner',
    hasMembersSelector: true,
    categoryId: '67c846bb905be95b6d5f1e75',
    // categoryId: '681a8b8f731ba25a81282d8a',
  },
  [EncumbranceTypes.PLEDGE_OR_GUARANTEE]: {
    sectionTitle: 'Creditor',
    hasMembersSelector: false,
  },
  [EncumbranceTypes.USUFRUCT]: {
    sectionTitle: 'Usufructuary',
    hasMembersSelector: true,
  },
  [EncumbranceTypes.EMBARGO]: {
    sectionTitle: 'Creditor',
    hasMembersSelector: false,
  },
  [EncumbranceTypes.RESTRICTIONS_ON_TRANSFERABILITY]: {
    sectionTitle: 'Titular',
    hasMembersSelector: false,
  },
  [EncumbranceTypes.PURCHASE_OR_SALE_OPTIONS]: {
    sectionTitle: 'Titular',
    hasMembersSelector: false,
  },
  [EncumbranceTypes.SHAREHOLDER_AGREEMENTS]: {
    sectionTitle: '',
    hasMembersSelector: false,
  },
  [EncumbranceTypes.TAX_LIENS]: {
    sectionTitle: 'Creditor',
    hasMembersSelector: false,
  },
  [EncumbranceTypes.REGISTRATION_ANNOTATIONS]: {
    sectionTitle: 'Beneficiary',
    hasMembersSelector: false,
  },
  [EncumbranceTypes.TRUSTS_OR_FIDUCIARIES]: {
    sectionTitle: 'Trustee',
    hasMembersSelector: false,
  },
  [EncumbranceTypes.OTHER]: {
    sectionTitle: 'Other',
    hasMembersSelector: false,
  },
};

/*
[{
  "_id": "679445d2c9ffbb6b1bf620c9",
  "name": "Activos"
},
{
  "_id": "679445dec9ffbb6b1bf620cc",
  "name": "Pasivos"
},
{
  "_id": "67bc2d2e4be48e31015f61e1",
  "name": "Bajas"
},
{
  "_id": "67c846a5905be95b6d5f1e72",
  "name": "Comprador"
},
{
  "_id": "67c846bb905be95b6d5f1e75",
  "name": "Cotitular"
},
{
  "_id": "67c846d2905be95b6d5f1e78",
  "name": "Usufructo"
},
{
  "_id": "67c846e4905be95b6d5f1e7b",
  "name": "Difunto"
},
{
  "_id": "67c846f7905be95b6d5f1e7e",
  "name": "Cedente"
},
{
  "_id": "67c84707905be95b6d5f1e81",
  "name": "Heredero"
},
{
  "_id": "67c8471a905be95b6d5f1e84",
  "name": "Cesionario"
},
{
  "_id": "67c8476e905be95b6d5f1e87",
  "name": "Tiene Cotitular(es)"
},
{
  "_id": "67c8478e905be95b6d5f1e8a",
  "name": "Tiene Usufructo(s)"
},
{
  "_id": "67c847b5905be95b6d5f1e8d",
  "name": "Cotitular Sin Acciones"
},
{
  "_id": "67c847d5905be95b6d5f1e90",
  "name": "Usufructuario Sin Acciones"
}]
  */
